export const getLandingPageHeaderStyles = (_, { palette = {} }) => ({
  container: {
    position: 'sticky',
    top: '0%',
    zIndex: '1000',
    backgroundColor: '#FFFFFF',
    width: '100%',
    height: '82px',
    display: 'flex',
    justifyContent: 'center',
  },
  innerContainer: {
    width: '1180px',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '& .brand-img': {
      width: '302px',
    },
  },
  'innerContainer-xl': {
    width: '980px',
  },
  'innerContainer-l': {
    width: '640px',
  },
  'innerContainer-m': {
    maxWidth: '480px',
    '& .brand-img': {
      width: '230px',
    },
  },
  'innerContainer-s': {
    width: '360px',
    '& .brand-img': {
      width: '150px',
    },
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  'button-m': {
    fontSize: '12px !important',
  },
  'button-s': {
    fontSize: '12px !important',
  },
  signUpButton: {
    backgroundColor: `${palette.black} !important`,
  },
  loginButton: {
    marginRight: '12px !important',
  },
});
